import { defineNuxtPlugin } from 'nuxt/app'

// Now also import the plugin for registration
import AM3ComponentsPlugin from '@/components/am3-generic/index'
import { vSubmit } from '@/components/am3-generic/inputs/AM3FormValidation'
import { vOverflowTooltip } from '@/directives/OverflowTooltip'

// Disable HMR for this module to prevent duplicate registration
if (import.meta.hot) {
  import.meta.hot.decline()
}

/**
 * Plugin to register all am3-generic components globally.
 * This ensures proper HMR by connecting all components to Vite's dependency graph.
 * By importing all components directly above, we ensure Vite knows about these dependencies.
 */
export default defineNuxtPlugin({
  name: 'am3-generic-components',
  enforce: 'pre', // Make sure this runs before other plugins
  setup(nuxtApp) {
    // Install all am3-generic components
    nuxtApp.vueApp.use(AM3ComponentsPlugin)

    nuxtApp.vueApp.directive('submit', vSubmit)
    nuxtApp.vueApp.directive('overflow-tooltip', vOverflowTooltip)

    // For development debugging only
    if (process.env.NODE_ENV === 'development') {
      console.log('am3-generic components registered globally with proper HMR support')
    }
  },
})
